import React, { PureComponent, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Card, CardBody, Col, Row } from "reactstrap";
import TablePagination from "@material-ui/core/TablePagination";
import Switch from "@material-ui/core/Switch";
import { withStyles } from "@material-ui/core/styles";
import moment from "moment";

import FinancingsListTable from "./FinancingsListTable";
import BuildingSearchAppBar from "../../../shared/components/building_filters/UnitsSearchAppBar";

import { _axiosCall } from "../../../shared/helpers/apicalls";
import {
	_formatNumber,
	_isEqual,
	_tranformTagsQuery,
	syncURLFilters,
	syncURLSearch,
	setURLFromState,
	setLocalStorage,
	deleteLocalStorage,
	syncGenericFilter,
	_objectEqual,
	mpndCohortQuery,
} from "../../../shared/helpers/utils";

import { _financingFilters } from "../../../shared/helpers/filters";

const PurpleSwitch = withStyles({
	switchBase: {
		color: "#780f9e",
		"&$checked": { color: "#780f9e" },
		"&$checked + $track": { backgroundColor: "#EDDEF5" },
	},
	checked: {},
	track: { backgroundColor: "#EDDEF5" },
})(Switch);

const buildingUrl = process.env.API_ROOT + "/query/";

const lsPre = "F1_";
const subFilterKey = "subFilters";
const defaultSubFilter = {
	min_recorded_date: null,
	max_recorded_date: null,
	min_document_date: null,
	max_document_date: null,
};

const financingExportFL = [
	"id",
	"document_id",
	"doc_type",
	"doc_type_desc",
	"document_date",
	"recorded_datetime",
	"document_amt",
	"party_1",
	"party_2",
	"full_street_address",
	"address_2_normalized",
	"borough",
	"zip",
	"block",
	"lot",
	"borough_code",
	"property_type",
];

class FinancingsSearchTable extends PureComponent {
	state = {
		order: syncGenericFilter("order", lsPre, "order", "desc"),
		orderBy: syncGenericFilter("order_by", lsPre, "orderBy", "document_date"),
		page: 0,
		rowsPerPage: 50,
		fetchInProgress: false,
		searchText: syncURLSearch(this.props, "searchText"),
		tableData: false,
		totalCount: 0,
		start: 0,
		pipelineOnly: true,
		subFilters: syncURLFilters(
			this.props,
			_financingFilters,
			subFilterKey,
			lsPre,
			defaultSubFilter
		),
	};

	defaultQ = "";

	fq = [
		"-property_type:(d* rg rv rp pa sc sp)",
		`address_2_normalized:""`,
		"doc_type:(mtge agmt asst sat cdec adec al&r mcon)",
	];

	fl = [
		"id",
		"document_id",
		"doc_type",
		"doc_type_desc",
		"document_date",
		"recorded_datetime",
		"document_amt",
		"party_1",
		"party_2",
		"full_street_address",
		"address_2_normalized",
		"borough",
		"borough_code",
		"block",
		"lot",
		"zip",
		"property_type",
	];

	q = "";
	unitFq = null;
	sort = "";

	componentDidMount() {
		this._getFinancings();
	}

	componentDidUpdate(prevProps, prevState) {
		const searchTagsChange = !_isEqual(
			prevProps.searchTags,
			this.props.searchTags
		);

		const subFilterChanged =
			_financingFilters.filter((item) => {
				return Array.isArray(item.search_key)
					? item.search_key.filter(
						(key) => this.state.subFilters[key] !== prevState.subFilters[key]
					).length > 0
					: this.state.subFilters[item.search_key] !==
					prevState.subFilters[item.search_key];
			}).length > 0;

		if (
			this.state.searchText !== prevState.searchText ||
			this.state.orderBy !== prevState.orderBy ||
			this.state.order !== prevState.order ||
			this.state.page !== prevState.page ||
			this.state.rowsPerPage !== prevState.rowsPerPage ||
			this.state.pipelineOnly !== prevState.pipelineOnly ||
			searchTagsChange ||
			subFilterChanged
		) {
			const resetPage =
				this.state.page === prevState.page ||
				this.state.rowsPerPage !== prevState.rowsPerPage;
			this._getFinancings(resetPage);
		}
	}

	handleRequestSort = (event, property) => {
		const orderBy = property;
		let order = "desc";
		const { orderBy: stateOrderBy, order: stateOrder } = this.state;
		if (stateOrderBy === property && stateOrder === "desc") {
			order = "asc";
		}
		this.setState({ order, orderBy });
	};

	handleChangePage = (event, page) => {
		this.setState({ page, start: page * this.state.rowsPerPage });
	};

	handleChangeRowsPerPage = (event) => {
		this.setState({ rowsPerPage: parseInt(event.target.value) });
	};

	_getSpecificFilter = (key) => {
		return (
			_financingFilters &&
			_financingFilters.filter(
				(filter) =>
					filter.search_key === key ||
					(filter.search_key && filter.search_key.includes(key))
			)[0]
		);
	};

	_getFinancings = async (resetPage) => {
		this.q = this.defaultQ;
		if (!this.state.fetchInProgress) {
			this.setState({
				fetchInProgress: true,
				tableData: false,
			});
		}

		const { searchTags } = this.props;
		const { orderBy, order } = this.state;
		const locQuery = _tranformTagsQuery(searchTags, "building");

		this.unitFq = this.fq.slice();

		if (this.state.pipelineOnly) {
			this.unitFq.push(
				`{!join from=alternate_addresses fromIndex=we3-buildings to=full_street_address}(${mpndCohortQuery})`
			);
		}

		if (locQuery) {
			this.q += this.q.length > 0 ? " AND " : "";
			this.q += `${locQuery}`;
		}

		if (
			this.state.subFilters &&
			Object.keys(this.state.subFilters).length > 0
		) {
			Object.keys(this.state.subFilters).forEach((key) => {
				const subFilterVal = this.state.subFilters[key];
				if (subFilterVal && subFilterVal !== "") {
					const theFilter = _financingFilters.filter(
						(filter) => filter.search_key === key
					);
					let qVal = null;

					if (theFilter && theFilter[0] && theFilter[0].text_filter) {
						qVal = subFilterVal
							.split(" ")
							.map((term) => `(${key}:*${term.toLowerCase()}*)`)
							.join(" AND ");
						if (qVal !== null) {
							this.q += this.q.length > 0 ? " AND " : "";
							this.q += `(${qVal})`;
						}
					} else if (theFilter && theFilter[0] && theFilter[0].multi_filter) {
						const values =
							theFilter.length > 0 &&
								theFilter[0].values.length > 0 &&
								theFilter[0].values.filter(
									(value) => subFilterVal.indexOf(value.filter) > -1
								).length > 0
								? theFilter[0].values
									.filter((value) => subFilterVal.indexOf(value.filter) > -1)
									.map((value) => value.search_value)
								: null;
						if (values !== null) {
							this.q += this.q.length > 0 ? " AND " : "";
							this.q += `(${key}:(${values.join(" ")}))`;
						}
					} else {
						qVal =
							theFilter.length > 0 &&
								theFilter[0].values &&
								theFilter[0].values.length > 0 &&
								theFilter[0].values.filter(
									(value) => value.filter === subFilterVal
								).length > 0
								? theFilter[0].values.filter(
									(value) => value.filter === subFilterVal
								)[0].search_value
								: null;
						if (qVal !== null) {
							if (theFilter[0].target && theFilter[0].target === "fq") {
								this.unitFq.push(qVal);
							} else {
								this.q += this.q.length > 0 ? " AND " : "";
								this.q += `(${key}:${qVal})`;
							}
						}
					}
				}
			});
		}

		/**** Price & Date query — replicated from Sales UnitsSearchTable pattern ****/
		let dateQ = "";
		let dateReplaceKeys = [];
		if (
			this.state.subFilters &&
			Object.keys(this.state.subFilters).length > 0
		) {
			let query_key;
			const queryCount = {};
			Object.keys(this.state.subFilters).forEach((key) => {
				const subFilterVal = this.state.subFilters[key];
				const filter = this._getSpecificFilter(key);
				query_key = filter && filter.filter_key;

				if (filter && filter.format_type && !filter.date_filter) {
					queryCount[key] = parseInt(subFilterVal);
					if (query_key in queryCount) {
						queryCount[query_key] += 1;
					} else {
						queryCount[query_key] = 1;
						queryCount[query_key + "Q"] = "";
					}
					const qArrayFilter = _financingFilters.filter(
						(f) =>
							f.price_filter &&
							Array.isArray(f.search_key) &&
							f.search_key.filter((skey) => skey === key).length > 0
					);
					if (qArrayFilter.length > 0) {
						if (queryCount[query_key + "Q"]) {
							const regex = new RegExp(`{${key}}`, "g");
							if (String(subFilterVal) === "NaN" || subFilterVal === "0") {
								queryCount[query_key + "Q"] = queryCount[
									query_key + "Q"
								].replace(regex, "*");
							} else {
								queryCount[query_key + "Q"] = queryCount[
									query_key + "Q"
								].replace(regex, subFilterVal);
							}
						} else {
							if (String(subFilterVal) === "NaN" || subFilterVal === "0") {
								queryCount[query_key + "Q"] = qArrayFilter[0].search_value
									.map((search) => search.replace(`{${key}}`, "*"))
									.join(" OR ");
							} else {
								queryCount[query_key + "Q"] = qArrayFilter[0].search_value
									.map((search) => search.replace(`{${key}}`, subFilterVal))
									.join(" OR ");
							}
						}
					}
					if (
						queryCount[query_key] === 2 &&
						!queryCount[query_key + "Q"].includes("[* TO *]") &&
						!queryCount[query_key + "Q"].includes("[ TO ]")
					) {
						this.q += this.q.length > 0 ? " AND " : "";
						this.q += "(";
						this.q += queryCount[query_key + "Q"];
						this.q += ")";
					}
				}

				if (subFilterVal && subFilterVal !== "") {
					const dateArrayFilter = _financingFilters.filter(
						(f) =>
							f.date_filter &&
							Array.isArray(f.search_key) &&
							f.search_key.filter((skey) => skey === key).length > 0
					);

					if (dateArrayFilter.length > 0) {
						dateReplaceKeys = [
							...dateReplaceKeys,
							...dateArrayFilter[0].search_key,
						];
						if (dateQ) {
							const regex = new RegExp(`{${key}}`, "g");
							dateQ = dateQ.replace(regex, moment(subFilterVal).toISOString());
						} else if (subFilterVal !== "0") {
							dateQ = dateArrayFilter[0].search_value
								.map((search) =>
									search.replace(
										`{${key}}`,
										moment(subFilterVal).toISOString()
									)
								)
								.join(" OR ");
						}
					}
				}
			});
		}

		if (dateQ) {
			dateReplaceKeys.forEach((key) => {
				const regex = new RegExp(`{${key}}`, "g");
				dateQ = dateQ.replace(regex, "*");
			});
			this.q += this.q.length > 0 ? " AND " : "";
			this.q += "(";
			this.q += dateQ;
			this.q += ")";
		}
		/**** Price & Date query end ****/

		setURLFromState(this.props, this.state);

		if (this.state.searchText && this.state.searchText.length > 0) {
			const text = this.state.searchText.replace(/ /g, "*").toLowerCase();
			this.q += this.q.length > 0 ? " AND " : "";
			this.q +=
				`(full_street_address:*${text}* OR party_1:*${text}* OR party_2:*${text}* OR document_id:*${text}*)`;
		}

		this.q = this.q.length > 0 ? this.q : "*:*";

		let sort = "document_date desc, recorded_datetime desc";
		if (orderBy && orderBy.length > 0) {
			sort = `${orderBy} ${order}`;
		}
		this.sort = sort;

		const axiosData = {
			url: buildingUrl + "we3-acris-real-property?cache=60",
			method: "post",
			query: {
				q: this.q,
				fq: this.unitFq,
				fl: this.fl.join(", "),
				sort,
				rows: this.state.rowsPerPage,
				start: resetPage ? 0 : this.state.start,
				wt: "json",
			},
		};

		const response = await _axiosCall(axiosData).catch((error) => {
			console.log("error: " + error);
		});

		const docs =
			response && response.docs
				? response.docs.map((d) => Object.assign({}, d))
				: [];

		this.setState({
			fetchInProgress: false,
			tableData: docs,
			totalCount: response && response.numFound ? response.numFound : 0,
			start: resetPage ? 0 : this.state.start,
			page: resetPage ? 0 : this.state.page,
		});
	};

	_setSubFilter = (search_key, search_val) => {
		const subF = Object.assign({}, this.state.subFilters, {
			[search_key]: search_val,
		});
		this.setState({ subFilters: subF, start: 0 });
		setLocalStorage(lsPre, subFilterKey, JSON.stringify(subF));
	};

	_setSubFilters = (subFilters) => {
		const subF = Object.assign({}, this.state.subFilters, subFilters);
		this.setState({ subFilters: subF, start: 0 });
		setLocalStorage(lsPre, subFilterKey, JSON.stringify(subF));
	};

	_resetSubFilter = () => {
		const subF = Object.assign({}, defaultSubFilter);
		this.setState({ subFilters: subF, start: 0 });
		deleteLocalStorage(lsPre, subFilterKey);
	};

	_setPipelineOnly = (val) => {
		this.setState({ pipelineOnly: val, page: 0, start: 0 });
	};

	_resetActive = () => {
		const isDefault =
			this.props.searchTags.length === 0 &&
			_objectEqual(defaultSubFilter, this.state.subFilters);
		return !isDefault;
	};

	_filterTableByInput = (name, eValue) => {
		this.setState({ searchText: eValue });
	};

	render() {
		const {
			order,
			orderBy,
			rowsPerPage,
			page,
			tableData,
			subFilters,
			totalCount,
			fetchInProgress,
			searchText,
			pipelineOnly,
		} = this.state;
		const { user } = this.props;

		return (
			<Col md={12} lg={12}>
				<Card>
					<CardBody style={{ padding: 0 }} className="unit_search">
						<BuildingSearchAppBar
							handleSearch={this._filterTableByInput}
							onRequestSort={this.handleRequestSort}
							subFilters={subFilters}
							searchText={searchText}
							setSubFilter={this._setSubFilter}
							resetSubFilter={this._resetSubFilter}
							_filters={
								user && user.role && user.role.indexOf("admin") >= 0
									? _financingFilters
									: _financingFilters.filter((item) => !item.admin_only)
							}
							{...this.props}
							placeHolder={"Building, Neighborhood or Borough"}
							numToShow={7}
							buildingStages={[]}
							setBuildingStage={() => {}}
							buildingAttributes={[]}
							hideBuildingStage
							setSubFilters={this._setSubFilters}
							resetActive={this._resetActive()}
							q={this.q}
							fq={this.unitFq}
							fl={financingExportFL}
							sort={this.sort}
							totalCount={totalCount}
							showExport
							core_name={"we3-acris-real-property"}
							export_name={"Financings Search"}
							title={"Export This Financings Search (CSV)"}
							description={
								<Fragment>
									<h4>
										<strong>
											Export this financings search for your own analysis.
										</strong>
									</h4>{" "}
									<br /> The export will include document details, parties, amounts and recorded dates.
								</Fragment>
							}
							hideOrganizations
							hidePeople
							hideProjects
						/>

						<div className="material-table__header-info unit_search">
							<Row>
								<Col md={12} style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
									<div className={`count_toggle`} style={{ marginRight: 24 }}>
										<div>
											<span className="bold-text">
												{totalCount > 0 ? _formatNumber(totalCount) : "--"}
											</span>
											{` `}Financings
										</div>
									</div>
									<div style={{ display: "flex", alignItems: "center" }}>
										<span style={{ fontSize: 14, fontWeight: 400, color: "#171F26", marginRight: 12 }}>
											All Financings
										</span>
										<PurpleSwitch
											checked={pipelineOnly}
											onChange={(e) => this._setPipelineOnly(e.target.checked)}
											size="small"
										/>
										<span style={{ fontSize: 14, fontWeight: 400, color: "#171F26", marginLeft: 12 }}>
											Pipeline Projects Only
										</span>
									</div>
								</Col>
							</Row>
						</div>

						<div className="material-table__wrap">
							<FinancingsListTable
								tableData={tableData || []}
								order={order}
								orderBy={orderBy}
								onRequestSort={this.handleRequestSort}
								fetchInProgress={fetchInProgress}
								user={user}
							/>
							{totalCount ? (
								<TablePagination
									component="div"
									className="material-table__pagination"
									count={totalCount}
									rowsPerPage={rowsPerPage}
									page={page}
									backIconButtonProps={{ "aria-label": "Previous Page" }}
									nextIconButtonProps={{ "aria-label": "Next Page" }}
									onChangePage={this.handleChangePage}
									onChangeRowsPerPage={this.handleChangeRowsPerPage}
									rowsPerPageOptions={[25, 50, 100]}
									dir="ltr"
									SelectProps={{
										inputProps: { "aria-label": "rows per page" },
										native: true,
									}}
								/>
							) : null}
						</div>
					</CardBody>
				</Card>
			</Col>
		);
	}
}

export default connect((state) => ({
	user: state.user,
	searchTags: Array.isArray(state.search.searchTags)
		? state.search.searchTags.slice()
		: [],
}))(withRouter(FinancingsSearchTable));
